import React from 'react'

export const MSI = () => {
  return (
    <p className="block text-center bg-slate-100 py-4 text-sm">Obtén 6 meses gratis de Apple Music con tu iPhone.**</p>
  )
}
